// extracted by css-extract-rspack-plugin
export default {"sidebarToggleButton":"SidebarList-module__sidebarToggleButton__NH8qh","sidebarHeading":"SidebarList-module__sidebarHeading__dZC8o","dialog":"SidebarList-module__dialog__klXGi"};